var _polygon, _rect, _rect2, _rect3, _circle, _polygon2, _path, _polygon3, _path2, _path3, _circle2, _path4, _path5, _polygon4, _rect4, _rect5, _rect6, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawPersonalOpinionsReQw29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "744.2px",
    height: "551.75px",
    viewBox: "0 0 744.2 551.75",
    enableBackground: "new 0 0 744.2 551.75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5E5E5",
    points: "374.315,248.985 137.014,248.985 92.902,298.121 92.902,248.985 51.957,248.985 51.957,70.312  374.315,70.312 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.815,
    y: 122.797,
    fill: "#FFFFFF",
    width: 216.643,
    height: 9.679
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104.815,
    y: 154.81,
    fill: "#FFFFFF",
    width: 216.643,
    height: 9.678
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104.815,
    y: 186.822,
    fill: "#FFFFFF",
    width: 216.643,
    height: 9.678
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#E6E6E6",
    cx: 93.555,
    cy: 320.048,
    r: 8.147
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9F616A",
    points: "628.598,540.263 618.514,540.263 613.715,501.367 628.598,501.367 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M631.17,550.039l-32.516-0.002v-0.41c0-6.99,5.666-12.656,12.654-12.656h0.002h19.859V550.039z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9F616A",
    points: "530.313,539.464 520.752,536.259 528.567,497.855 542.678,502.585 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M529.645,549.55l-30.83-10.336l0.131-0.391c2.223-6.627,9.396-10.197,16.023-7.977l0,0l18.83,6.313 L529.645,549.55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M542.745,339.244l-21.838,184.73l21.418,1.807c0,0,33.691-181.623,44.076-160.109 c10.387,21.516,23.113,156.076,23.113,156.076h21.256c0,0,5.451-209.953-16.805-220.339L542.745,339.244z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#9F616A",
    cx: 578.158,
    cy: 183.322,
    r: 21.515
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M565.372,212.753l27.449,2.226c0,0,21.887,0.371,30.789,6.306s-8.531,42.658-8.531,42.658 s-4.533,14.56-1.113,21.144c11.096,21.361,9.451,37.813,9.451,37.813s-22.805,5.217-62.125,15.604c0,0-24.482,9.645-23.74,4.451 s8.16-64.545,8.16-64.545v-61.576L565.372,212.753z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M613.391,180.99c-1.1-6.127-3.559-14.818-9.039-21.408c0.172,0.001,0.344,0.008,0.518,0.003 c1.883-0.055,4.025-0.649,4.805-2.365c0.512-1.4,0.223-2.967-0.752-4.094c-0.971-1.093-2.133-2.001-3.43-2.68 c1.322,0.803,3.191,1.548,4.246,0.417c0.553-0.696,0.654-1.649,0.258-2.445c-0.4-0.774-0.963-1.452-1.648-1.989 c-2.223-1.965-4.652-3.681-7.25-5.116c-2.01-1.111-4.654-2.002-6.459-0.582c-1.838,1.447-1.543,4.266-1.07,6.557 c-1.029-0.602-2.188-0.951-3.377-1.019c-1.227-0.035-2.309,0.796-2.59,1.99c-0.035,0.93,0.418,1.81,1.195,2.32 c-7.094-1.167-16.156,0.157-27.744,5.519c0,0-11.236,3.745-11.807,18.535c-0.059,2.366,0.205,4.729,0.779,7.023 c0.633,2.681,2.885,15.834,0.184,21.15l13.531,4.821l0.156-8.105c-10.518-15.18-5.322-20.751-1.227-29.881 c0.02-0.049,0.076-0.073,0.125-0.053c0.02,0.008,0.035,0.022,0.047,0.04c0.756,1.298,3.656,5.749,13.635,5.749l-3.855-3.856 c0,0,16.967,6.941,23.137,6.941c0,0,4.627,3.085,0,7.712s-14.756,11.438-9.355,19.922c5.398,8.483,4.934,11.493,4.934,11.493 l12.338-6.941c0,0,7.537-14.912,8.875-19.304C613.647,188.012,613.936,184.461,613.391,180.99z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#23CACB",
    points: "465.118,348.181 710.596,348.181 710.596,484.244 679.417,484.244 679.417,521.662 645.825,484.244  465.118,484.244 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 505.37,
    y: 388.15,
    fill: "#FFFFFF",
    width: 164.975,
    height: 7.371
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 505.37,
    y: 412.529,
    fill: "#FFFFFF",
    width: 164.975,
    height: 7.369
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 505.37,
    y: 436.906,
    fill: "#FFFFFF",
    width: 164.975,
    height: 7.369
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9F616A",
    d: "M626.299,261l-14.398,3.5l-0.109,29.14l-16.195,55.893c-3.918,3.1-4.584,8.789-1.484,12.709 c3.1,3.918,8.789,4.584,12.709,1.484c2.965-2.346,4.16-6.289,2.994-9.887l19.359-57.863L626.299,261z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9F616A",
    d: "M530.469,260.387l17.273,4.935l0.109,29.14l16.193,55.895c3.92,3.098,4.584,8.787,1.484,12.707 c-3.098,3.92-8.787,4.584-12.707,1.484c-2.967-2.346-4.16-6.289-2.994-9.887l-19.359-57.863V260.387z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M604.692,218.317l3.568-1.163c2.002-0.653,4.182-0.502,6.076,0.421l0,0c0,0,10.387,0.742,11.869,8.161 c1.484,7.419,5.094,72.263,5.094,72.263l-22-7L604.692,218.317z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M554.614,218.317L548.299,218l-2-1c0,0-11.717,1.317-13.199,8.736c-1.484,7.419-5.801,74.263-5.801,74.263 l22-6L554.614,218.317z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M191.776,481.152l10.428-9.096c-0.446-6.535-1.26-13.039-2.438-19.482l-5.755,2.436l5.339-4.658 c-1.537-7.951-3.058-13.119-3.058-13.119s-21.04,18.684-32.813,41.477l5.165,16.988l-7.889-11.234 c-1.173,2.713-2.174,5.496-2.998,8.334c-8.209,28.637-5.512,54.535,6.026,57.842c11.538,3.309,27.546-17.227,35.755-45.865 c2.396-9.174,3.371-18.66,2.892-28.129L191.776,481.152z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M219.39,503.419l13.629-2.396c2.996-5.824,5.661-11.813,7.982-17.938l-6.185-0.891l6.978-1.227 c2.795-7.602,4.165-12.813,4.165-12.813s-27.669,5.119-49.529,18.545l-4.361,17.213l-0.946-13.695 c-2.406,1.717-4.702,3.58-6.874,5.584c-21.831,20.271-32.908,43.836-24.74,52.631c8.167,8.795,32.485-0.508,54.316-20.781 c6.792-6.613,12.531-14.23,17.015-22.584L219.39,503.419z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M743.2,551h-618c-0.552,0-1-0.447-1-1s0.448-1,1-1h618c0.553,0,1,0.447,1,1S743.752,551,743.2,551z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawPersonalOpinionsReQw29);
export default __webpack_public_path__ + "static/media/undraw_personal_opinions_re_qw29.759312d7422e813c3e331bd85043cce5.svg";
export { ForwardRef as ReactComponent };